import { URL } from "./URLVariables";

export const changeFieldName = (id, body, token) => {

    return fetch(`${URL}/api/v1/field/${id}`, {
        method: 'PUT',
        headers: {
            'Authorization': `sessionid ${token}`,
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(body),
    })
        .then(response => {
            if (response.ok) {
                return response.json()
            } else {
                throw new Error(`${response.status}`);
            }
        })
        .catch(error => {
            throw new Error(`: ${error.message}`);
        });
}

export const changePipeName = (id, pipeInfo, token) => {

    return fetch(`${URL}/api/v1/pipe/${id}`, {
        method: 'PUT',
        headers: {
            'Authorization': `sessionid ${token}`,
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(pipeInfo),
    })
        .then(response => {
            if (response.ok) {
                return response.json()
            } else {
                throw new Error(`${response.status}`);
            }
        })
        .catch(error => {
            throw new Error(`: ${error.message}`);
        });
}

export const changeZoneName = (zoneInfo) => {
    //NEEDS TOKEN

    return fetch(`${URL}/api/zone`, {
        method: 'PUT',
        headers: {
            // 'Authorization': `sessionid ${token}`,
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(zoneInfo),
    })
        .then(response => {
            if (response.ok) {
                return response.json()
            } else {
                throw new Error(`${response.status}`);
            }
        })
        .catch(error => {
            throw new Error(`: ${error.message}`);
        });
}

export const changeUserRole = (token, body, id) => {
    return fetch(`${URL}/api/v1/group/user/${id}`, {
        method: 'PUT',
        headers: {
            'Authorization': `sessionid ${token}`,
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(body),
    })
        .then(response => {
            if (response.ok) {
                return response.json()
            } else {
                throw new Error(`${response.status}`);
            }
        })
        .catch(error => {
            throw new Error(`: ${error.message}`);
        });
}

export const changeWaterSensorSensitivity = (token, body, id) => {
    return fetch(`${URL}/api/v1/ws/${id}`, {
        method: 'PUT',
        headers: {
            'Authorization': `sessionid ${token}`,
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(body),
    })
        .then(response => {
            if (response.ok) {
                return response.json()
            } else {
                throw new Error(`${response.status}`);
            }
        })
        .catch(error => {
            throw new Error(`: ${error.message}`);
        });
}

export const updateWsZoneBinding = (token, id, body) => {
    return fetch(`${URL}/api/v1/ws/${id}/bind`, {
        method: 'PUT',
        headers: {
            'Authorization': `sessionid ${token}`,
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(body),
    })
        .then(response => {
            if (response.ok) {
                return response.json()
            } else {
                throw new Error(`${response.status}`);
            }
        })
        .catch(error => {
            throw new Error(`: ${error.message}`);
        });
}


export const unbindWsZoneBinding = (token, id, body) => {
    return fetch(`${URL}/api/v1/ws/${id}/unbind`, {
        method: 'PUT',
        headers: {
            'Authorization': `sessionid ${token}`,
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(body),
    })
        .then(response => {
            if (response.ok) {
                return response.json()
            } else {
                throw new Error(`${response.status}`);
            }
        })
        .catch(error => {
            throw new Error(`: ${error.message}`);
        });
}